export default "__VITE_ASSET__B5BB2NUv__"